import {MessageBox} from 'element-ui'
import Vue from 'vue'
import {Module} from 'vuex'
import {RootState, SaveGuardState} from '@/types/store/states'

// @ts-ignore
import messages from '@/lang/index';

const store: Module<SaveGuardState, RootState> = {
  namespaced: true,
  state: {
    statuses: {}
  },
  getters: {},
  mutations: {
    setStatus: (state, item) => {
      if (!item.key) return;
      if (state.statuses[item.key]) {
        state.statuses[item.key] = item.value
      } else {
        Vue.set(state.statuses, item.key, item.value);
      }
    }
  },
  actions: {
    confirm (context, key) {
      return new Promise((resolve, reject) => {
        if (context.state.statuses[key]) {
          return MessageBox.confirm(
            messages.labels.not_saved_data_would_lost,
            messages.labels.cancel,
            {
              confirmButtonText: messages.labels.yes,
              cancelButtonText: messages.labels.cancel,
              type: 'warning',
              customClass: 'noHideSidebar'
            }
          )
            .then(() => {
              context.commit('setStatus', {key: key, value: false});
              resolve();
            })
            .catch(e => {
              reject(e);
            });
        } else {
          resolve();
        }
      })
    }
  }
}

export default store